import BaseAPI from "../api";

const path: string = "admission-front";

export class AdmissionFrontApi extends BaseAPI {
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static patch(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }
  static patch_term_payment(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/term_payment`, body);
  }
  static sent(id: number): Promise<any> {
    return this.api.patch(`${path}/${id}/sent`);
  }
  static register_payment_file(body: any): Promise<any> {
    return this.api.post(`${path}/register_payment_file`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static student_file(body: any): Promise<any> {
    return this.api.post(`${path}/student_file`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  static findOne(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static findExam(id: any, id_period_examination_student: any): Promise<any> {
    return this.api.get(`${path}/${id}/exam/${id_period_examination_student}`);
  }
  static patchExam(
    id: any,
    id_period_examination_student: any,
    body: any
  ): Promise<any> {
    return this.api.patch(
      `${path}/${id}/exam/${id_period_examination_student}`,
      body
    );
  }

  static list(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static downloadFileZip(
    id_admission_student: number
  ): Promise<any> {
    return this.api.get(
      `${path}/${id_admission_student}/file_zip`,
      {
        responseType: "arraybuffer",
      }
    );
  }
}
